import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageCheck"><Path d="M10.5 21.5H4.5V2.5H19.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.25 19.0832L15.3929 21.25L20.75 14.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageCheck;
